import React from 'react';
import { Switch } from '../../shadcn/switch';
import { cn } from '../../shadcn/lib/utils';

const Toggle = ({
  checked,
  onCheckedChange,
  disabled = false,
  label,
  description,
  // size removed to simplify API; switch uses design size
  className,
  labelPosition = "right"
}) => {
  const ToggleComponent = (
    <Switch
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={cn(className)}
      data-testid="toggle-switch"
    />
  );

  if (!label) {
    return ToggleComponent;
  }

  const LabelComponent = (
    <div className="flex flex-col gap-1">
      <label
        className={cn(
          "text-sm font-medium leading-none cursor-pointer",
          disabled && "cursor-not-allowed opacity-50"
        )}
        onClick={() => !disabled && onCheckedChange?.(!checked)}
      >
        {label}
      </label>
      {description && (
        <p className={cn(
          "text-xs text-gray-500",
          disabled && "opacity-50"
        )}>
          {description}
        </p>
      )}
    </div>
  );

  return (
    <div className={cn(
      "flex items-center gap-3",
      labelPosition === "left" && "flex-row-reverse"
    )}>
      {ToggleComponent}
      {LabelComponent}
    </div>
  );
};

export default Toggle;
